module.exports = __webpack_public_path__ + "img/medicine.fa6508d5.svg";